import { Component, inject, OnInit, signal, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Notification } from '../_core/notification';
import { IAppNotification } from '../core.interface';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { BadgeModule } from 'primeng/badge';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-notifications',
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    BadgeModule,
    ScrollPanelModule,
    DividerModule,
    ProgressSpinnerModule,
  ],
  templateUrl: './notifications.html',
  styleUrl: './notifications.scss',
})
export class Notifications implements OnInit {
  public $notification = inject(Notification);

  // Estado local para la selección y búsqueda
  public selectedNotification = signal<IAppNotification | null>(null);
  public searchQuery = signal<string>('');
  private searchSubject = new Subject<string>();

  constructor() {
    // Efecto para manejar la búsqueda con debounce
    this.searchSubject.pipe(debounceTime(400), distinctUntilChanged()).subscribe((query) => {
      this.$notification.fetchNotifications(query, true);
    });
  }

  ngOnInit(): void {
    // Si no hay notificaciones precargadas, las pedimos
    if (this.$notification.notifications().length === 0) {
      this.$notification.fetchNotifications();
    }
  }

  onSearchChange(query: string) {
    this.searchSubject.next(query);
  }

  async selectNotification(n: IAppNotification) {
    this.selectedNotification.set(n);
    if (!n.isRead) {
      await this.$notification.markAsRead(n.id);
    }
  }

  loadMore() {
    this.$notification.fetchNotifications(this.searchQuery());
  }

  getSeverity(type: string): 'info' | 'success' | 'warn' | 'danger' | 'secondary' {
    switch (type.toLowerCase()) {
      case 'alert':
        return 'danger';
      case 'info':
        return 'info';
      case 'billing':
        return 'success';
      default:
        return 'secondary';
    }
  }
}
